import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTironParaActualizar } from '../../hooks/useTironParaActualizar';

/**
 * El aviso de «tirar para actualizar» arriba de la bandeja (punto 10). Es un componente aparte para que el estado
 * del gesto viva aquí: cada `touchmove` repinta este aviso, no los cientos de filas de `Chats`.
 *
 * @param {{ alActualizar: () => Promise<unknown> }} props
 */
export default function IndicadorDeTiron({ alActualizar }) {
  const { t } = useTranslation('chats');
  const tiron = useTironParaActualizar(alActualizar);
  if (!(tiron.distancia > 0 || tiron.actualizando)) return null;
  return (
    <div
      role="status"
      style={{
        height: tiron.actualizando ? '36px' : `${tiron.distancia}px`, overflow: 'hidden',
        display: 'flex', alignItems: 'flex-end', justifyContent: 'center', paddingBottom: '6px',
        fontSize: '13px', color: '#4a5568',
      }}
    >
      {tiron.actualizando ? t('list.pullRefreshing') : tiron.armado ? t('list.pullRelease') : t('list.pullToRefresh')}
    </div>
  );
}
